
let imgTemplate = '//img.youtube.com/vi/#/maxresdefault.jpg';
const frameVideo = '<iframe width="100%" height="100%" src="_srcValue" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"allowFullScreen></iframe>';
const $videos = $('.js-content-video');

if ($(".js-content-slider").length) {
    const contentSlider = new Swiper(".js-content-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        grabCursor: true,
        autoHeight: true,
        loop: true,
        navigation: {
            nextEl: ".js-content-slider-next",
            prevEl: ".js-content-slider-prev",
        },
        pagination: {
            el: ".js-content-slider-pagination",
            type: "bullets",
        },
        on: {
            init: function () {
                setPreviewVideoPictures();
            },
            slideChangeTransitionEnd: function () {
                $('.js-content-video')
                    .filter('._play')
                    .closest('.js-content-slider')
                    .removeClass('_video-playing');
                $('.js-content-video')
                    .filter('._play')
                    .removeClass('_play')
                    .find('iframe').remove();
            }
        }
    });
}

if ($videos.length > 0) {
    setPreviewVideoPictures();
}


App.document.on('click', '.js-content-video', function (e) {
    const $currVideo = $(this);
    const videoUrl = $currVideo.data('src');
    const videoUrls = prepareYoutubeVideoUrl(videoUrl);

    if (!$currVideo.is('_play')) {
        $currVideo.append(videoUrls[0]);
        $currVideo.addClass('_play');

        if ($currVideo.closest('.js-content-slider').length) {
            $currVideo.closest('.js-content-slider').addClass('_video-playing');
        }
    }

    e.preventDefault();
});

function prepareYoutubeVideoUrl(youtubeVideoUrl) {
    const currUrl = `${youtubeVideoUrl}${youtubeVideoUrl.indexOf('?') > 0 ? '&' : '?'}autoplay=1`;
    let currVideoSource = frameVideo.replace('_srcValue', currUrl);
    let _previewPics = youtubeVideoUrl.split('/');
    let previewPicUrl = _previewPics[_previewPics.length - 1];

    previewPicUrl = imgTemplate.replace('#', previewPicUrl.split('?')[0]);

    return [currVideoSource, previewPicUrl];
}

function setPreviewVideoPictures() {
    $('.js-content-video').each(function () {
        const $currVideo = $(this);
        const videoUrls = prepareYoutubeVideoUrl($currVideo.data('src'));
        const currPreviewUrl = $currVideo.data('preview') ? $currVideo.data('preview') : videoUrls[1];

        if ($currVideo.find('.content-video__preview').length === 0) {
            $currVideo.append(`<div class="content-video__preview" style="background-image: url(${currPreviewUrl})"></div>`);
        }
    });
}

$(".js-anchor-list a, .js-anchor").click(function () {
    let anchor = $(this).attr("href");

    $("html, body").animate({scrollTop: $(anchor).offset().top - 130}, 500);
});
